import styled from 'styled-components'

export const Root = styled.div`
  display: flex;
  justify-content: center;
`
